import priceDisplay from './price-display.component'

const module = angular.module('ac.components.price-display', [])

module.component('priceDisplay', priceDisplay)

export default module.name
